import { useEffect } from 'react';
import {
  StorageOffers,
  StorageOffersSearchParams,
} from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useStorageOffers(params: StorageOffersSearchParams) {
  const storageOffers = useAxios(
    (axios, signal, params: StorageOffersSearchParams) =>
      axios.request<StorageOffers>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/storage-offer/page`,
        method: 'GET',
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    storageOffers.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return storageOffers;
}

export type StorageOffersRequest = ReturnType<typeof useStorageOffers>;
